var _effectorFileName = "/src/page-content/teachers/components/teachers/teacher-card.tsx";
import Image from 'next/image';
import { MagicCard } from '@/shared/components/animation/magic-container';
import StarIcon from '@/shared/components/icons/star-icon';
import { APP_TITLE } from '@/shared/lib/seo/meta';
interface TeacherCardProps {
  name: string;
  surname: string;
  patronymicName: string;
  img: string;
  facts: Array<string>;
  className?: string;
}
export const TeacherCard = (props: TeacherCardProps) => {
  const {
    name,
    surname,
    img,
    facts,
    className = ''
  } = props;
  return <MagicCard className={className}>
      <div className="mb-4">
        <Image src={img} width={300} height={300} alt={`Английский онлайн в ${APP_TITLE}`} className="mx-auto h-24 w-24 rounded-full object-cover sm:h-32 sm:w-32" />
      </div>

      <p className="mb-4 text-center font-semibold sm:text-lg">{name}</p>

      <ul className="space-y-2">
        {facts && facts.map((fact, index) => {
        return <li key={index} className="flex items-center gap-x-3">
                <StarIcon className="h-5 w-5 shrink-0 text-purple-300" />
                <span className="text-sm">{fact}</span>
              </li>;
      })}
      </ul>
    </MagicCard>;
};